import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';

const HomePage: React.FC = () => {
  return (
    <MainLayout>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-purple-50 via-white to-orange-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-purple-800 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="text-white text-2xl font-bold">AI</span>
              </div>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-purple-800">
                AI短剧网页版
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
              智能AI短剧生成和播放平台，支持互动剧情选择，为您提供个性化的娱乐体验
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/create"
                className="px-8 py-4 bg-gradient-to-r from-purple-600 to-purple-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
              >
                立即开始创作
              </Link>
              <Link
                to="/projects"
                className="px-8 py-4 bg-white text-purple-600 font-semibold rounded-xl shadow-lg border border-purple-200 hover:bg-purple-50 transition-all duration-200"
              >
                查看我的项目
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              核心功能特色
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              从创意到成片，AI全程陪伴，让短剧创作变得简单高效
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* AI剧本生成 */}
            <div
              onClick={() => window.location.href = '/create'}
              className="bg-gradient-to-br from-purple-50 to-white p-8 rounded-2xl shadow-lg border border-purple-100 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 bg-purple-600 rounded-xl flex items-center justify-center mb-4">
                <span className="text-white text-xl">📝</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">AI剧本生成</h3>
              <p className="text-gray-600 mb-4">
                智能生成短剧剧本大纲和对白，支持多种类型和风格，让创意源源不断
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• 多种剧类型选择</li>
                <li>• 智能情节构建</li>
                <li>• 角色对白生成</li>
              </ul>
            </div>

            {/* 角色设定 */}
            <div
              onClick={() => window.location.href = '/character-setting'}
              className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-2xl shadow-lg border border-orange-100 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center mb-4">
                <span className="text-white text-xl">👥</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">角色设定</h3>
              <p className="text-gray-600 mb-4">
                创建和管理角色形象，构建丰富的人物关系网络，让角色更加立体
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• 角色档案管理</li>
                <li>• 性格特征设定</li>
                <li>• 关系图谱展示</li>
              </ul>
            </div>

            {/* 分镜设计 */}
            <div
              onClick={() => window.location.href = '/storyboard'}
              className="bg-gradient-to-br from-green-50 to-white p-8 rounded-2xl shadow-lg border border-green-100 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 bg-green-500 rounded-xl flex items-center justify-center mb-4">
                <span className="text-white text-xl">🎬</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">分镜设计</h3>
              <p className="text-gray-600 mb-4">
                智能分镜建议，专业的镜头语言和转场设计，让视觉效果更专业
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• 镜头语言建议</li>
                <li>• 时间轴管理</li>
                <li>• 场景切换设计</li>
              </ul>
            </div>

            {/* 智能编辑 */}
            <div
              onClick={() => window.location.href = '/create'}
              className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl shadow-lg border border-blue-100 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center mb-4">
                <span className="text-white text-xl">✏️</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">智能编辑</h3>
              <p className="text-gray-600 mb-4">
                专业的文本编辑器，支持剧本格式化和AI辅助优化，提升内容质量
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• 剧本格式化</li>
                <li>• AI写作建议</li>
                <li>• 协作编辑功能</li>
              </ul>
            </div>

            {/* 多媒体生成 */}
            <div
              onClick={() => window.location.href = '/resource-center'}
              className="bg-gradient-to-br from-pink-50 to-white p-8 rounded-2xl shadow-lg border border-pink-100 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 bg-pink-500 rounded-xl flex items-center justify-center mb-4">
                <span className="text-white text-xl">🎭</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">多媒体生成</h3>
              <p className="text-gray-600 mb-4">
                AI生成角色形象和场景概念图，为创作提供视觉参考和灵感
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• 角色形象生成</li>
                <li>• 场景概念图</li>
                <li>• 视觉风格参考</li>
              </ul>
            </div>

            {/* 项目管理 */}
            <div
              onClick={() => window.location.href = '/projects'}
              className="bg-gradient-to-br from-indigo-50 to-white p-8 rounded-2xl shadow-lg border border-indigo-100 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 bg-indigo-500 rounded-xl flex items-center justify-center mb-4">
                <span className="text-white text-xl">📁</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">项目管理</h3>
              <p className="text-gray-600 mb-4">
                完整的项目管理系统，支持团队协作和版本控制，提升工作效率
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• 项目版本管理</li>
                <li>• 团队协作功能</li>
                <li>• 进度跟踪系统</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 热门短剧推荐 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              热门AI短剧
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              精选AI生成的优质短剧内容，支持互动剧情选择，体验不一样的观看乐趣
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* 短剧卡片1 */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group">
              <div className="relative">
                <div className="aspect-video bg-gradient-to-br from-purple-600 to-purple-800 flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition">
                      <span className="text-white text-2xl">▶️</span>
                    </div>
                    <p className="text-white font-semibold">立即观看</p>
                  </div>
                </div>
                <div className="absolute top-4 right-4 bg-black/60 text-white px-3 py-1 rounded-full text-sm">
                  3:20
                </div>
                <div className="absolute top-4 left-4 bg-purple-600 text-white px-3 py-1 rounded-full text-sm">
                  互动剧情
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">时间胶囊</h3>
                <p className="text-gray-600 mb-4">一个关于时间旅行者试图改变历史的故事，每个选择都可能影响未来。</p>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <span>👁 12.5k</span>
                    <span>❤️ 892</span>
                    <span>💬 156</span>
                  </div>
                  <span className="text-sm text-purple-600 font-semibold">科幻</span>
                </div>
                <Link
                  to="/player/1"
                  className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 rounded-lg transition text-center block"
                >
                  开始观看
                </Link>
              </div>
            </div>

            {/* 短剧卡片2 */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group">
              <div className="relative">
                <div className="aspect-video bg-gradient-to-br from-pink-600 to-pink-800 flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition">
                      <span className="text-white text-2xl">▶️</span>
                    </div>
                    <p className="text-white font-semibold">立即观看</p>
                  </div>
                </div>
                <div className="absolute top-4 right-4 bg-black/60 text-white px-3 py-1 rounded-full text-sm">
                  2:50
                </div>
                <div className="absolute top-4 left-4 bg-pink-600 text-white px-3 py-1 rounded-full text-sm">
                  互动剧情
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">咖啡馆的邂逅</h3>
                <p className="text-gray-600 mb-4">都市爱情故事，关于缘分和选择，你的每个决定都会影响故事的走向。</p>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <span>👁 8.9k</span>
                    <span>❤️ 756</span>
                    <span>💬 124</span>
                  </div>
                  <span className="text-sm text-pink-600 font-semibold">爱情</span>
                </div>
                <Link
                  to="/player/2"
                  className="w-full bg-pink-600 hover:bg-pink-700 text-white font-semibold py-3 rounded-lg transition text-center block"
                >
                  开始观看
                </Link>
              </div>
            </div>

            {/* 短剧卡片3 */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group">
              <div className="relative">
                <div className="aspect-video bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition">
                      <span className="text-white text-2xl">🎬</span>
                    </div>
                    <p className="text-white font-semibold">即将上线</p>
                  </div>
                </div>
                <div className="absolute top-4 right-4 bg-black/60 text-white px-3 py-1 rounded-full text-sm">
                  敬请期待
                </div>
                <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm">
                  AI生成
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">古风探案</h3>
                <p className="text-gray-600 mb-4">古代探案故事，需要观众协助破案，体验推理的乐趣。</p>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <span>🔥 即将上线</span>
                    <span>🎯 悬疑</span>
                  </div>
                </div>
                <button
                  disabled
                  className="w-full bg-gray-300 text-gray-500 font-semibold py-3 rounded-lg cursor-not-allowed"
                >
                  即将开放
                </button>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/explore"
              className="inline-flex items-center px-6 py-3 bg-purple-600 text-white font-semibold rounded-xl shadow-lg hover:bg-purple-700 transition-all duration-200"
            >
              探索更多短剧
              <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      {/* 互动体验特色 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              为什么选择AI短剧？
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              颠覆传统观看体验，让您成为故事的主角
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎭</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">互动剧情</h3>
              <p className="text-gray-600">您的选择决定故事走向，每个决定都可能带来不同的结局</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🤖</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">AI生成</h3>
              <p className="text-gray-600">先进AI技术生成高质量内容，提供个性化的观看体验</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎬</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">专业制作</h3>
              <p className="text-gray-600">精良的制作水准，媲美传统影视剧的视听体验</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-pink-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📱</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">随时观看</h3>
              <p className="text-gray-600">无需下载，网页直接观看，随时随地享受互动乐趣</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-purple-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            开启您的AI创作之旅
          </h2>
          <p className="text-xl text-purple-100 mb-8">
            立即体验AI短剧创作的强大功能，让创意变为现实
          </p>
          <Link
            to="/create"
            className="inline-flex items-center px-8 py-4 bg-white text-purple-600 font-semibold rounded-xl shadow-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-200"
          >
            免费开始创作
            <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </section>

    </MainLayout>
  );
};

export default HomePage;